module.exports = __webpack_public_path__ + "img/home-service-jilin.43386d65.png";